// flagSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  flag: false,
};

const flagSlice = createSlice({
  name: "flag",
  initialState,
  reducers: {
    setFlag(state, action) {
      state.flag = action.payload;
    },
    toggleFlag(state) {
      state.flag = !state.flag;
    },
    resetFlag(state) {
      state.flag = false;
    },
  },
});

export const flagActions = flagSlice.actions;
export default flagSlice.reducer;
